"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");
/**
 * Simple utilities for prices. Can be replaced, if it will be too simple.
 *
 * @author JPk
 */


var PriceUtils =
/*#__PURE__*/
function () {
  function PriceUtils() {
    _classCallCheck(this, PriceUtils);
  }

  _createClass(PriceUtils, null, [{
    key: "round",

    /**
     * Rounds number by these rules as defined in LOG-7394.
     *
     * For weighted:
     * - 0.1-9.999 - down, 1 decimal places, at least 0.1 (example: 8.73 -> 8.7)
     * - 10-29.999 - down, nearest .5 or .9 (example: 15.27 -> 14.9, 16.7 -> 16.5)
     * - 30-∞ - round, then largest integer with 5 or 9 as last digit smaller than the number (example: 114 -> 109, 117 -> 115)
     *
     * For pieces:
     * - 0.1-9.999 - down, 1 decimal places, decimal place must not be zero, at least 0.1 (example: 8.73 -> 8.7)
     * - 10-29.999 - down, nearest .5 or .9 (example: 15.27 -> 14.9, 16.7 -> 16.5)
     * - 30-149,999 - down, nearest .9 (example: 40.80 -> 39.90)
     * - 150-∞ - down, nearest integer (example: 164.9 -> 164)
     *
     * Add config object param, if intervals must be configured.
     * There is a test for this method in PriceUtils.test, use it if this method moves.
     *
     * @param price
     * @param weighted
     * @param stand
     */
    value: function round(price) {
      var weighted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var stand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var roundedPrice = typeof price === 'number' ? big_decimal_1.bigdecimal(price) : price; // LOG-7657: Don't round weighted items

      if (weighted) {
        return roundedPrice;
      }

      if (stand) {
        return big_decimal_1.bigdecimal(0);
      }

      if (roundedPrice.lt(0.1)) {
        // 0.01 -> 0.1
        roundedPrice = big_decimal_1.bigdecimal(0.1);
      } else if (roundedPrice.lt(10)) {
        // 4.07 -> 3.9
        // 5.19 -> 5.1
        roundedPrice = roundedPrice.round(1, big_decimal_1.DecimalRoundingEnum.ROUND_DOWN);

        if (roundedPrice.equals(roundedPrice.round(0, big_decimal_1.DecimalRoundingEnum.ROUND_DOWN))) {
          roundedPrice = roundedPrice.minus(0.1);
        }
      } else if (roundedPrice.lt(30)) {
        var decimalPart = roundedPrice.minus(roundedPrice.floor());

        if (decimalPart.gte(0.5) && decimalPart.lt(0.9)) {
          // 16.7 -> 16.5
          roundedPrice = roundedPrice.floor().plus(0.5);
        } else if (decimalPart.gte(0.9)) {
          // 16.95 -> 16.9
          roundedPrice = roundedPrice.floor().plus(0.9);
        } else {
          // 16.4 -> 15.9
          roundedPrice = roundedPrice.floor().minus(0.1);
        }
      } else {
        if (roundedPrice.lt(150)) {
          var _decimalPart = roundedPrice.minus(roundedPrice.floor());

          if (_decimalPart.gte(0.9)) {
            // 106.95 -> 106.9
            roundedPrice = roundedPrice.floor().plus(0.9);
          } else {
            // 106.8 -> 105.9
            roundedPrice = roundedPrice.floor().minus(0.1);
          }
        } else {
          // 200.5 -> 200
          roundedPrice = roundedPrice.floor();
        }
      }

      return roundedPrice;
    }
  }]);

  return PriceUtils;
}();

exports.PriceUtils = PriceUtils;